import { parseInstrument } from '../../instrumentUtils';
import type { WidgetDefinition } from '../WidgetDefinition';
import { faBriefcase } from '@fortawesome/pro-regular-svg-icons/faBriefcase';
import type { OrdersWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';
import type { OrdersWidgetViewModel } from 'src/store/types';

class OrdersWidgetDefinition implements WidgetDefinition<OrdersWidgetViewModel, OrdersWidgetModel> {
    type = 'orders' as const;
    nameKey = 'widgets::orders::name' as const;
    roles = ['widgets::orders'];
    icon = faBriefcase;
    category = 'widgets::categories::risk' as const;

    /**
     * Converts an Orders or Manual Review widget from contract model to view model
     */
    toViewModel(widget: OrdersWidgetModel): OrdersWidgetViewModel {
        return {
            ...widget,
            instrument: parseInstrument(''),
        };
    }

    /**
     * Converts an Orders or Manual Review widget from view model to contract model
     */
    toContractModel(widget: OrdersWidgetViewModel): OrdersWidgetModel {
        const { instrument: _instrument, ...contractWidget } = widget;
        return contractWidget;
    }
}

export const ordersWidgetDefinition = new OrdersWidgetDefinition();
